import { useState } from 'react'
import { useDispatch } from 'react-redux'

export const useRowEditingLazy = ({
    dataKey,
    localData,
    setLocalData,
    originalData,
    data,
    validateData,
    onSave,
    startEditing,
    stopEditing,
    toastRef
}) => {
    const [validationErrors, setValidationErrors] = useState({})
    const dispatch = useDispatch()

    const isFieldChanged = (rowData, field) => {
        if (originalData === undefined) return false
        const origData = Object.values(originalData)
        const originalRowData = origData.find(row => row[dataKey] === rowData[dataKey])

        if (!originalRowData) return false

        const originalValue = originalRowData[field]
        const currentValue = rowData[field]

        // Handle Date comparison - both are Date objects
        if (originalValue instanceof Date && currentValue instanceof Date) {
            return originalValue.toISOString() !== currentValue.toISOString()
        }

        // Handle Date vs String comparison (original is string, current is Date)
        if (typeof originalValue === 'string' && currentValue instanceof Date) {
            return new Date(originalValue).toISOString() !== currentValue.toISOString()
        }

        // Handle String vs Date comparison (original is Date, current is string)
        if (originalValue instanceof Date && typeof currentValue === 'string') {
            return originalValue.toISOString() !== new Date(currentValue).toISOString()
        }

        // Standard comparison for non-Date fields
        return originalValue !== currentValue
    }

    const onRowEditInit = (e) => {
        if (startEditing) {
            dispatch(startEditing())
        }
    }

    const onRowEditSave = (e) => {
        if (stopEditing) {
            dispatch(stopEditing())
        }
    }

    const rowEditValidator = (rowData) => {
        const errors = validateData(rowData)
        if (Object.keys(errors).length > 0) {
            const rowIndex = data.findIndex(row => row[dataKey] === rowData[dataKey])
            setValidationErrors({ [rowIndex]: errors })
            if (toastRef?.current) {
                toastRef.current.show({ severity: 'error', summary: 'Error', detail: Object.values(errors).join(', ') })
            }
            return false
        }
        else {
            onSave(rowData)
            setValidationErrors({})
            const updatedData = [...localData]
            const rowIndex = updatedData.findIndex(row => row[dataKey] === rowData[dataKey])
            if (rowIndex !== -1) {
                updatedData[rowIndex] = rowData
                setLocalData(updatedData)
            }
            return true
        }
    }

    const onRowEditCancel = (e) => {
        dispatch(stopEditing())
    }

    return {
        validationErrors,
        isFieldChanged,
        onRowEditInit,
        onRowEditSave,
        rowEditValidator,
        onRowEditCancel
    }
}
